import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth"; // <--- Add this import
const firebaseConfig = {
    apiKey: "AIzaSyC87K5J9uHvCwxnX2HZdyM4KtmY48BmWV8",
    authDomain: "notex-61043.firebaseapp.com",
    projectId: "notex-61043",
    storageBucket: "notex-61043.firebasestorage.app",
    messagingSenderId: "932331468174",
    appId: "1:932331468174:web:693a7b3f7adc80c253a0df",
    measurementId: "G-ZT31NWFMZN"
};


const app = initializeApp(firebaseConfig);

// Export both db and auth
export const db = getFirestore(app);
export const auth = getAuth(app); // <--- Add this export